var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorseRacing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10002_5236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9016V10.3079C0 6.93286 2.125 3.90161 5.3125 2.77661L10.625 0.901611C11.2812 0.651611 12 1.15161 12 1.87036C12 2.21411 11.8125 2.52661 11.5312 2.71411L10.5 3.40161C12 3.40161 13.3438 4.33911 13.875 5.74536L15.375 9.80786C15.75 10.7766 15.5 11.9016 14.7812 12.6204C14.2812 13.1204 13.5938 13.4016 12.875 13.4016H12.7812C11.9688 13.4016 11.1875 13.0579 10.6562 12.4329L9.65625 11.2141C9.28125 11.3391 8.90625 11.4016 8.5 11.4016H8.46875C8.28125 11.4016 8.09375 11.4016 7.90625 11.3704C7.78125 11.3391 7.6875 11.3391 7.5625 11.3079C6.65625 11.0579 5.90625 10.4641 5.4375 9.65161C5.3125 9.43286 5 9.33911 4.75 9.49536C4.53125 9.62036 4.4375 9.93286 4.59375 10.1829C5.34375 11.4641 6.71875 12.3704 8.3125 12.4016L9.78125 14.6204C9.90625 14.8079 9.96875 15.0266 9.96875 15.2766C9.96875 15.9016 9.46875 16.4016 8.84375 16.4016H1.5C0.65625 16.4016 0 15.7454 0 14.9016ZM10.25 7.40161C10.6562 7.40161 11 7.08911 11 6.65161C11 6.24536 10.6562 5.90161 10.25 5.90161C9.8125 5.90161 9.5 6.24536 9.5 6.65161C9.5 7.08911 9.8125 7.40161 10.25 7.40161Z",
    fill: "currentColor",
    fillOpacity: 1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10002_5236",
    x: 0,
    y: 0.651611,
    width: 15.75,
    height: 16.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10002_5236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10002_5236",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorseRacing);
export default ForwardRef;